/**
 * GROQ filter: event is publicly listable / sitemap-eligible.
 * Hidden when `hideEvent` is on, or when `autoHideWhenPast` is on and the
 * event end (or start) date is in the past.
 */
export const eventIsPublicFilter = `hideEvent != true && (autoHideWhenPast != true || coalesce(endDate, startDate) >= now())`;

/** Same filter when the event is accessed via a reference (`@->`). */
export const eventRefIsPublicFilter = `@->hideEvent != true && (@->autoHideWhenPast != true || coalesce(@->endDate, @->startDate) >= now())`;
